// jQuery
jQuery(function ($) {
  $('.js-gnavBtn').click(function () {
    $(this).toggleClass('is-open');
    $('.gnav').toggleClass('is-open');

    if ($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', true);
    } else {
      $(this).attr('aria-expanded', false);
    }
  });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });
  // -----------------------------
  // ハンバーガーメニュー
  // -----------------------------
  $('.gnavBtn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.gnav').toggleClass('is-open');
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
    $(this).attr('aria-label', label);
    var hidden = $('.gnav').attr('aria-hidden') === 'true';
    $('.gnav').attr('aria-hidden', !hidden);
  });
  $('.gnav a').on('click', function () {
    $('.gnav').removeClass('is-open');
    $('.gnavBtn').removeClass('is-open');
    $('.gnavBtn').attr('aria-expanded', 'false');
    $('.gnavBtn').attr('aria-label', 'メニューを開く');
    $('.gnav').attr('aria-hidden', 'true');
  });

  // -----------------------------
  // アコーディオン
  // -----------------------------
  $('.js-accordion').click(function () {   // アコーディオンメニュー全体
    $(this).find('.js-accordionContents').slideToggle();   // アコーディオンの隠されている要素
    $(this).toggleClass("is-open");   // メニューが開いたときのスタイル変化
  });

  $('.js-accordionRecruit').click(function () {   // アコーディオンメニュー全体
    $(this).next('.js-accordionContents').slideToggle();   // アコーディオンの隠されている要素
    $(this).toggleClass("is-open");   // メニューが開いたときのスタイル変化
  });

  // タブ切り替え
  $('.js-tab').on('click', function () {
    var idx = $('.js-tab').index(this);
    $(this).addClass('is-active').siblings('.js-tab').removeClass('is-active');

    var panelArea = $(this).closest('.js-tab_area').next('.js-panel_area');
    var panels = panelArea.find('.js-panel');
    panels.removeClass('is-active');
    panels.eq(idx).addClass('is-active');
  });

  // ページ読み込み時に初期タブをアクティブに設定 いる？
  $(document).ready(function () {
    var initialTabIdx = 0; // 初期タブのインデックス
    var parentTabs = $('.js-tab');
    if (parentTabs.length > 0) {
      parentTabs.eq(initialTabIdx).click();
    }
  });

});

// JavaScript
// -----------------------------
// テーブルで空欄時にis-emptyを入れる
// -----------------------------
document.addEventListener('DOMContentLoaded', function () {
  const tableCells = document.querySelectorAll('.js-inspectionTable td');

  tableCells.forEach(function (cell) {
    if (!cell.textContent.trim()) {
      cell.classList.add('is-empty');
    }
  });
});

// -----------------------------
// 改行したときにspanを自動生成
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
  let paragraphs = document.querySelectorAll(".js-span");
  paragraphs.forEach(p => {
    let html = p.innerHTML;
    let lines = html.split('<br>');
    let newHtml = lines.map((line, index) => {
      // 最後の行には <br> を追加しない
      return index === lines.length - 1 ? `<span>${line}</span>` : `<span>${line}</span><br>`;
    }).join('');
    p.innerHTML = newHtml;
  });
});

// -----------------------------
// ホバーで画像を切り替え
// -----------------------------
document.addEventListener('DOMContentLoaded', function () {
  const archiveItems = document.querySelectorAll('.recrruitNumber-archive li');
  const numberItems = document.querySelectorAll('.obviouslyNumber-item');

  archiveItems.forEach(item => {
    item.addEventListener('mouseover', function () {
      const targetIndex = this.getAttribute('data-target');

      numberItems.forEach(numberItem => {
        if (numberItem.getAttribute('data-index') === targetIndex) {
          numberItem.classList.add('active');
        } else {
          numberItem.classList.remove('active');
        }
      });
    });
  });
});



